import styled from 'styled-components';

export const AboutContainer = styled.main``;

export const AboutBanner = styled.section`
    position: relative;
    display: flex;
    align-items: center;

    min-height: 60rem;
    
    img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
    }

    &::before, &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;

        width: 100%;
        height: 100%;

        background: linear-gradient(45deg, var(--color-primary), var(--color-secondary), #f7431e);
        opacity: .8;
    }

    &::after {
        z-index: 3;
        background: #000;
        opacity: .4;
    }

    .content {
        position: relative;
        z-index: 5;

        padding: 5rem 0;

        .text {
            width: 45%;

            h1 {
                position: relative;
                margin: 0 0 3rem;

                color: rgba(255, 255, 255, 1);
                font-size: 4rem;
                font-weight: 300;
                padding-top: 3rem;

                &::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;

                    width: 5rem;
                    height: 2px;

                    background: #fff;
                }
            }

            p {
                color: rgba(255, 255, 255, .7);
                font-size: 1.8rem;
                line-height: 150%;
            }
        }
    }
`;

export const Section = styled.section`
    min-height: 100vh;

    .content {
        padding: 7rem 0;
    }

    &#about-content {
        overflow: hidden;

        .circle-lines {
            position: absolute;
            top: 0;
            left: -13%;

            transform: translate(-50%, -50%);

            width: 60rem;
            height: 60rem;

            border-radius: 50%;
            border: 1px solid #000;

            &::before, &::after {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);

                border: 1px solid #000;
                border-radius: 50%;
            }

            &::before {
                width: 85%;
                height: 85%;
            }

            &::after {
                width: 65%;
                height: 65%;
            }
        }

        .content {
            position: relative;
            padding: 13rem 0;
            z-index: 5;

            .heading {
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;

                .text {
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    width: 70%;

                    h1 {
                        font-size: 4rem;
                        line-height: 5rem;
                    }

                    p {
                        width: 80%;
                        margin-top: 3rem;
                        font-size: 1.8rem;
                        line-height: 150%;
                    }
                }
            }

            .video {
                display: flex;
                justify-content: center;

                margin-top: 10rem;

                iframe {
                    position: relative;
                    z-index: 10;

                    width: 960px;
                    height: 615px;

                    border-radius: 2rem;
                    box-shadow: 4rem 4rem 4rem rgb(0 0 0 / 11%);
                    box-shadow: 0rem 6rem 13rem rgb(0 0 0 / 14%);
                }
            }
        }
    }
`;